import React, { useEffect, useState } from 'react';

import useURL from '@/hooks/use_url';
import ThinLayout from '@/components/ThinLayout';
import BenefitsCard from '@/components/commons/benefitsCard/BenefitsCard';
import benefitsCardDataResolver from '@/components/commons/benefitsCard/cardsData';

function SignUp() {
    const source = useURL().source as string;
    const [card, setCard] = useState<string>('');

    useEffect(() => {
        const effectiveSource = source || localStorage.getItem('source');
        let effectiveCard;

        switch (effectiveSource) {
        case 'calendly':
            effectiveCard = 'calendly_v1';
            break;
        case 'linkedin':
            effectiveCard = 'linkedin_v1';
            break;
        default:
            effectiveCard = 'generic_v1';
            break;
        }
        setCard(effectiveCard);
        localStorage.setItem('benefits', effectiveCard);
    }, [source, setCard]);

    if (card === '') return null;

    const { cardProps, internalCards } = benefitsCardDataResolver(card);

    return (
        <BenefitsCard cardProps={cardProps} internalCards={internalCards} />
    );
}

SignUp.getLayout = function getLayout(page) {
    return <ThinLayout>{page}</ThinLayout>;
};

export default SignUp;
